"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectValuesById = exports.selectDevicesByPdid = exports.selectDevicesById = exports.selectDeviceValueByParams = exports.getHasData = exports.getComponents = exports.getBuildings = exports.getActiveStructure = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _constants = require("../../utils/constants");
var _paulCorePackage = require("paul-core-package");
const getComponents = _ref => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref;
  return (components === null || components === void 0 ? void 0 : components.structure) || {};
};
exports.getComponents = getComponents;
const getActiveStructure = _ref2 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref2;
  return (components === null || components === void 0 ? void 0 : components.activeStructure.total) || {};
};
exports.getActiveStructure = getActiveStructure;
const getBuildings = _ref3 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref3;
  return (components === null || components === void 0 ? void 0 : components.buildings) || [];
};
exports.getBuildings = getBuildings;
const getHasData = _ref4 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref4;
  return (components === null || components === void 0 ? void 0 : components.hasData) || false;
};
exports.getHasData = getHasData;
const selectDevicesById = _ref5 => {
  let {
    [_constants.packageKey]: {
      components
    } = {}
  } = _ref5;
  return (components === null || components === void 0 ? void 0 : components.devices.byId) || {};
};
exports.selectDevicesById = selectDevicesById;
const selectDevicesByPdid = function selectDevicesByPdid() {
  let thingPDIDDeviceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _ref6 => {
    let {
      [_constants.packageKey]: {
        components
      } = {}
    } = _ref6;
    if (!(components !== null && components !== void 0 && components.devices.byId) || !thingPDIDDeviceList.length) return [];
    return thingPDIDDeviceList.map(thingPDIDDevice => components === null || components === void 0 ? void 0 : components.devices.byId[thingPDIDDevice]);
  };
};
exports.selectDevicesByPdid = selectDevicesByPdid;
const selectValuesById = _ref7 => {
  let {
    [_paulCorePackage.constants.packageKey]: {
      devices
    } = {}
  } = _ref7;
  return (devices === null || devices === void 0 ? void 0 : devices.values.byId) || {};
};

/** @todo move to core selectDeviceValueByParams */
exports.selectValuesById = selectValuesById;
const selectDeviceValueByParams = (thingPDIDDevice, displayNameId) => _ref8 => {
  var _ref9;
  let {
    [_paulCorePackage.constants.packageKey]: {
      devices
    } = {}
  } = _ref8;
  return (_ref9 = (devices === null || devices === void 0 ? void 0 : devices.values.byId[thingPDIDDevice]) || {}) === null || _ref9 === void 0 ? void 0 : _ref9[displayNameId];
};
exports.selectDeviceValueByParams = selectDeviceValueByParams;